import { render, staticRenderFns } from "./jyfw.vue?vue&type=template&id=00ccbe03&scoped=true"
import script from "./jyfw.vue?vue&type=script&lang=js"
export * from "./jyfw.vue?vue&type=script&lang=js"
import style0 from "./jyfw.vue?vue&type=style&index=0&id=00ccbe03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ccbe03",
  null
  
)

export default component.exports